module.exports = require('./helpers/bundle-url').getBundleURL('kmvYf') + "katharina-reboly.4c550ae5.jpg" + "?" + Date.now();